export default __webpack_public_path__ + "static/media/linkedin_icon.0d52768f.png";